import { combineReducers } from "redux";
import RairerReducer from "./accountReducer";

const reducerCombiner = combineReducers({
    account: RairerReducer
});

export default reducerCombiner;